import React from "react";
import "./Internship_Program_Card.css";
import { Card, Form } from "react-bootstrap";
import Blue_btn from "../../common_btn/blue_btn/Blue_btn";

// const Internship_Program_Card = ({
//   companyLogo,
//   companyTitle,
//   countryFlag,
//   title,
//   description,
//   image,
//   details,
//   benefits,
//   requirements,
//   documents,
//   onViewDetails,
//   showBadge = false,
//   status = "under_review", // under_review | accepted | refused
// }) => {
//   const statusConfig = {
//     under_review: {
//       text: "Under Review",
//       className: "badge_under_review",
//     },
//     accepted: {
//       text: "Accepted",
//       className: "badge_accepted",
//     },
//     refused: {
//       text: "Refused",
//       className: "badge_refused",
//     },
//   };

//   return (
//     <div className="internship_program_card">
//       {/* HEADER */}
//       <div className="internship_header">
//         <img src={companyLogo} alt="Company Logo" className="internship_logo" />
//         <h5 className="top_title">{companyTitle}</h5>

//         {/*  STATUS BADGE */}
//         {showBadge && (
//           <span className={`status_badge ${statusConfig[status].className}`}>
//             {statusConfig[status].text}
//           </span>
//         )}
//       </div>

//       {/* IMAGE */}
//       <div className="internship_program_img_holder">
//         <img className="internship_image" src={image} alt="program" />
//       </div>

//       {/* BODY */}
//       <div className="internship_card_body">
//         <div className="title_row">
//           <Card.Title className="internship_title">{title}</Card.Title>
//           <img src={countryFlag} className="flag_icon" alt="Flag" />
//         </div>

//         <Card.Text className="internship_desc">{description}</Card.Text>

//         {/* DETAILS */}
//         <div className="info_block">
//           <h6 className="info_block_title">Details</h6>
//           <ul className="info_block_list">
//             Start Date: <strong>{details.start}</strong>
//             <br />
//             End Date: <strong>{details.end}</strong>
//             <br />
//             Working Hours: <strong>{details.hours}</strong>
//           </ul>
//         </div>

//         {/* BENEFITS */}
//         <div className="info_block">
//           <h6 className="info_block_title">Benefits</h6>
//           <ul className="info_block_list">
//             Meals Provided: <strong>{benefits.meals}</strong>
//             <br />
//             Uniform Provided: <strong>{benefits.uniform}</strong>
//             <br />
//             Laundry Service: <strong>{benefits.laundry}</strong>
//             <br />
//             Accommodation: <strong>{benefits.accommodation}</strong>
//           </ul>
//         </div>

//         {/* REQUIREMENTS */}
//         <div className="info_block">
//           <h6 className="info_block_title">Requirements</h6>
//           <ul className="info_block_list">
//             <div>
//               French Level:
//               <strong>{requirements.french}</strong>
//             </div>
//             <div>
//               English Level:
//               <strong>{requirements.english}</strong>
//             </div>
//           </ul>
//         </div>

//         {/* DOCUMENTS */}
//         <div className="info_block">
//           <h6 className="info_block_title">Documents</h6>
//           <div className="form_holder">
//             <Form>
//               <ul className="info_block_list">
//                 {documents.map((doc, index) => (
//                   <li key={index}>
//                     <Form.Check label={doc} name="group1" type={"radio"} />
//                   </li>
//                 ))}
//               </ul>
//             </Form>
//           </div>
//         </div>

//         {/* BUTTON */}
//         <div className="btn_holder">
//           <Blue_btn btn_text="View Details" onClick={onViewDetails} />
//         </div>
//       </div>
//     </div>
//   );
// };

const Internship_Program_Card = ({
  companyLogo,
  companyTitle,
  countryFlag,
  title,
  description,
  image,
  details,
  benefits,
  requirements,
  documents,
  onViewDetails,
  showBadge = false,
  status = "under_review",
}) => {
  const statusConfig = {
    under_review: { text: "Under Review", className: "badge_under_review" },
    accepted: { text: "Accepted", className: "badge_accepted" },
    refused: { text: "Refused", className: "badge_refused" },
  };

  return (
    <div className="internship_program_card">
      {/* HEADER */}
      <div className="internship_header">
        <img src={companyLogo} alt="Company Logo" className="internship_logo" />
        <h5 className="top_title">{companyTitle}</h5>

        {showBadge && (
          <span className={`status_badge ${statusConfig[status]?.className}`}>
            {statusConfig[status]?.text}
          </span>
        )}
      </div>

      {/* IMAGE */}
      <div className="internship_program_img_holder">
        <img className="internship_image" src={image} alt="program" />
      </div>

      {/* BODY */}
      <div className="internship_card_body">
        <div className="title_row">
          <Card.Title className="internship_title">{title}</Card.Title>
          <img src={countryFlag} className="flag_icon" alt="Flag" />
        </div>

        <Card.Text className="internship_desc">{description}</Card.Text>

        {/* DETAILS */}
        {details && (
          <div className="info_block">
            <h6 className="info_block_title">Details</h6>
            <ul className="info_block_list">
              Start Date: <strong>{details.start}</strong>
              <br />
              End Date: <strong>{details.end}</strong>
              <br />
              Working Hours: <strong>{details.hours}</strong>
            </ul>
          </div>
        )}

        {/* BENEFITS */}
        {benefits && (
          <div className="info_block">
            <h6 className="info_block_title">Benefits</h6>
            <ul className="info_block_list">
              Meals Provided: <strong>{benefits.meals}</strong>
              <br />
              Uniform Provided: <strong>{benefits.uniform}</strong>
              <br />
              Laundry Service: <strong>{benefits.laundry}</strong>
              <br />
              Accommodation: <strong>{benefits.accommodation}</strong>
            </ul>
          </div>
        )}

        {/* REQUIREMENTS */}
        {requirements && (
          <div className="info_block">
            <h6 className="info_block_title">Requirements</h6>
            <ul className="info_block_list">
              <div>
                French Level: <strong>{requirements.french}</strong>
              </div>
              <div>
                English Level: <strong>{requirements.english}</strong>
              </div>
            </ul>
          </div>
        )}

        {/* DOCUMENTS */}
        {documents?.length > 0 && (
          <div className="info_block">
            <h6 className="info_block_title">Documents</h6>
            <div className="form_holder">
              <Form>
                <ul className="info_block_list">
                  {documents.map((doc, index) => (
                    <li key={index}>
                      <Form.Check
                        label={doc}
                        name="group1"
                        type="radio"
                        disabled
                      />
                    </li>
                  ))}
                </ul>
              </Form>
            </div>
          </div>
        )}

        {/* BUTTON */}
        <div className="btn_holder">
          <Blue_btn btn_text="View Details" onClick={onViewDetails} />
        </div>
      </div>
    </div>
  );
}; 

export default Internship_Program_Card;
